var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"market-view"},[_c('p',{staticClass:"title"},[_vm._v(_vm._s(_vm.state.lan.marketv.title))]),_c('div',{staticClass:"table"},[_c('fa-table')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }